module.exports = __webpack_public_path__ + "img/20_line.d59cbcde.png";